import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgV2Pencil = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "16px",
	height: "15px",
	viewBox: "0 0 16 15",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(-334.000000, -91.000000)",
			fill: "currentColor",
			children: /* @__PURE__ */ _jsx("g", {
				transform: "translate(39.000000, 89.000000)",
				children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M297.886714,14.3353339 L297.886714,11.7019516 L306.321954,3.83313122 L308.123321,5.83117331 L300.410202,14.3353339 L297.886714,14.3353339 Z M309.634367,7.29857828 C310.388585,6.48923422 310.366757,5.19698554 309.587542,4.414199 L307.788522,2.60693373 C307.008443,1.8232791 305.721933,1.79401141 304.911055,2.54523727 L295.919081,10.8757157 L295.919081,16.2932389 L301.252349,16.2932389 L309.634367,7.29857828 Z" }) }) })
			})
		})
	})
});
export default SvgV2Pencil;
